import React, { useEffect, useState } from 'react';
import { BRU_EVIDENCES_COLUMNS } from 'constants/reports';
import { BruEvidenceData } from 'store/ducks/Reporting/types';
import { useFilterOptions } from 'utils/hooks/useFilterOptions';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import Helpers from 'utils/Helpers';
import ApiService from 'utils/ApiCalls';
import CustomTable from 'components/Tables/CustomTable';
import * as Styled from './BruEvidences.styled';

const BruEvidences: React.FC = () => {
  const { loading } = useFilterOptions();
  const [data, setData] = useState<BruEvidenceData[]>([]);
  const { orgContext, lang } = useSelector((state: RootState) => ({
    orgContext: state.global.hierarchicalLevelsScope,
    lang: state.global.lang
  }));
  const filterParams = Helpers.toApiFilters(orgContext);
  const normalizedFilters = Helpers.normalizeFilters(
    Helpers.toApiFilters(orgContext)
  );

  const handleDisplay = async () => {
    try {
      if (!orgContext || Object.keys(orgContext).length === 0) return;
      const hasFilters = Object.keys(filterParams).length > 0;
      if (!hasFilters) return;

      const response = await ApiService.getBruEvidences(
        lang,
        normalizedFilters
      );
      const responseData = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      const formattedData = responseData.map((item: any, index: number) => {
        const evidences = Object.values(item.EVIDENCES || {});

        return {
          ...item,
          key: item.id || index,
          evd_description: evidences.map((e: any) => e.description),
          evd_approved: evidences.map((e: any) => e.approved),
          evd_approver_name: evidences.map((e: any) => e.approver_name),
          evd_reviewed: evidences.map((e: any) => e.reviewed),
          evd_reviewer_name: evidences.map((e: any) => e.reviewer_name),
          evd_valid_from: evidences.map((e: any) => e.valid_from),
          evd_valid_to: evidences.map((e: any) => e.valid_to),
          evd_sol_desc: evidences.map((e: any) => e.sol_desc),
          evd_created_by: evidences.map((e: any) => e.created_by),
          evd_created_on: evidences.map((e: any) => e.created_on),
          evd_unused: evidences.map((e: any) => e.evd_unused)
        };
      });
      setData(formattedData);
    } catch (error) {
      console.error('Failed to fetch BRU Evidences data:', error);
    }
  };

  useEffect(() => {
    if (!lang) return;
    if (!orgContext || Object.keys(orgContext).length === 0) return;

    handleDisplay();
  }, [lang, orgContext]);

  return (
    <Styled.VerticalSpace direction='vertical' size='large'>
      <CustomTable
        drawTable={true}
        itemsCount={data.length}
        columns={BRU_EVIDENCES_COLUMNS}
        dataSource={data}
        scroll={{ x: 1600, y: 400 }}
        loading={loading}
        rowKey={(record: BruEvidenceData) => record.key}
        sticky
      />
    </Styled.VerticalSpace>
  );
};

export default BruEvidences;
